import styled from "styled-components";

import banner from "../../../images/js_register_banner.jpg";
import jobIcon from "../../../images/job-icon-sprite.png";
import bullet from "../../../images/right_tab_bullet.jpg";
import blueGreenBg from "../../../images/blue_green_bg.jpg";
import mobileAppBg from "../../../images/mobile-app-bg.jpg";

export const Container = styled.div`
  .captcha_img {
    img {
      width: 372px;
    }
    clear: both;
    margin-bottom: 20px;
  }
`;

export const ApplicationIcon = styled.div`
  width: 74px;
  height: 74px;
  float: left;
  margin: 0 15px 0 auto;
  background: url(${jobIcon}) top center no-repeat;
  background-position: -592px -2px;
  @media only screen and (max-width: 480px) {
    margin: auto;
    float: unset;
  }
`;

export const ProfileIcon = styled.div`
  width: 74px;
  height: 74px;
  float: left;
  margin: 0 15px 0 auto;
  background: url(${jobIcon}) top center no-repeat;
  background-position: -674px -2px;
  @media only screen and (max-width: 480px) {
    margin: auto;
    float: unset;
  }
`;

export const SearchIcon = styled.div`
  width: 74px;
  height: 74px;
  float: left;
  margin: 0 15px 0 auto;
  background: url(${jobIcon}) top center no-repeat;
  background-position: -755px -2px;
  @media only screen and (max-width: 480px) {
    margin: auto;
    float: unset;
  }
`;

export const RightPane = styled.div`
  float: right;
  width: 42%;
  @media only screen and (max-width: 480px) {
    min-height: 300px;
    width: 100%;
    float: unset;
    margin-bottom: 20px;
  }
`;

export const LeftPane = styled.div`
  float: left;
  width: 50%;
  @media only screen and (max-width: 480px) {
    min-height: 300px;
    width: 100%;
    float: unset;
    margin-bottom: 20px;
  }
`;

export const Process = styled.div`
  float: left;
  margin: 0 0 30px;
  clear: both;
  @media only screen and (max-width: 480px) {
    float: unset;
    margin-bottom: 20px;
    text-align: center;
    clear: both;
  }
  .process-text {
    margin-bottom: 20px;
  }
  h2 {
    margin: 5px 0 8px;
    width: 100%;
    float: left;
    color: #fff;
    font-size: 21px;
    font-weight: 500;
    padding: 0;
  }
  p {
    width: 100%;
    float: left;
    color: #fff;
    font-size: 16px;
    margin: 0;
    padding: 0;
  }
`;

export const GreyBlock = styled.div`
  width: 100%;
  float: left;
  background-color: #f5f5f5;
  padding: 70px 0;
  .box {
    width: 32.6%;
    margin: 0 0.5%;
    float: left;
    min-height: 368px;
    border: 1px solid #c2c2c2;
    border-radius: 8px;
    text-align: center;
    padding: 30px;
    @media only screen and (max-width: 480px) {
      min-height: 300px;
      width: 100%;
      float: unset;
      margin-bottom: 20px;
    }
  }
  .box-left {
    width: 32.6%;
    margin: 0 0.5% 0 0;
    float: left;
    min-height: 368px;
    border: 1px solid #c2c2c2;
    border-radius: 8px;
    text-align: center;
    padding: 30px;
    @media only screen and (max-width: 480px) {
      min-height: 300px;
      width: 100%;
      float: unset;
      margin-bottom: 20px;
    }
  }
  .box-right {
    width: 32.6%;
    margin: 0 0 0 0.5%;
    float: left;
    min-height: 368px;
    border: 1px solid #c2c2c2;
    border-radius: 8px;
    text-align: center;
    padding: 30px;
    @media only screen and (max-width: 480px) {
      min-height: 300px;
      width: 100%;
      float: unset;
    }
  }
  .application-icon {
    width: 94px;
    height: 94px;
    margin: 0 auto;
    background: url(${jobIcon}) top center no-repeat;
    background-position: -290px -1px;
  }
  .search-icon {
    width: 94px;
    height: 94px;
    margin: 0 auto;
    background: url(${jobIcon}) top center no-repeat;
    background-position: -389px -1px;
  }
  .hired-icon {
    width: 94px;
    height: 94px;
    margin: 0 auto;
    background: url(${jobIcon}) top center no-repeat;
    background-position: -489px -1px;
  }
`;

export const MobileApp = styled.div`
  width: 100%;
  float: left;
  background: url(${mobileAppBg}) top center no-repeat;
  padding: 45px 0 0;
  background-size: cover;
  .mobile-app-left {
    color: #fff;
    h1 {
      margin: 0 0 10px;
      text-transform: uppercase;
      font-size: 30px;
      font-weight: 600px;
    }
    p {
      font-size: 15px;
      margin: 0 0 20px;
    }
    .button {
      margin: 30px 0;
      text-align: center;
    }
  }
`;

export const DownloadBlock = styled.div`
  width: 100%;
  float: left;
  padding: "100px 0 110px";
  background-color: #f3f5f5;
  text-align: center;
  h1 {
    text-align: center;
    color: #8c9494;
    font-size: 30px;
    font-weight: 700;
    margin: "0 0 30px";
  }
  a {
    @media only screen and (max-width: 540px) {
      display: block;
    }
  }
  input {
    text-align: center;
    @media only screen and (max-width: 540px) {
      width: 350px;
      left: unset;
    }
    width: 520px;
    display: inline-block;
    border: 2px solid #bbc3c2;
    border-radius: 50px;
    font-size: 18px;
    position: relative;
    left: 30px;
    background-color: #fff;
    color: #8c9494;
    font-family: Arial;
    padding: 17px;
    margin: auto;
  }
  .submit-btn {
    @media only screen and (max-width: 540px) {
      right: unset;
      margin: 20px 0;
    }
    display: inline-block;
    background-color: #39b54a;
    color: #fff;
    text-transform: uppercase;
    position: relative;
    right: 35px;
    font-weight: 600;
    font-size: 18px;
    padding: 17px 45px 18px;
    border-radius: 50px;
  }
`;

export const styles = {
  banner: {
    fontFamily: "Raleway, sans-serif",
    width: "100%",
    float: "left",
    background: `url(${banner}) top center no-repeat`,
    backgroundSize: "cover",
    margin: 0,
    padding: "80px 0 0",
    color: "#fff",
    h1: {
      width: "100%",
      float: "left",
      margin: "20px 0",
      padding: "0 20px",
      fontSize: 24,
      color: "#fff",
      fontWeight: 400,
      textTransform: "uppercase",
    },
    rightTab: {
      width: "100%",
      float: "left",
      background: "rgba(0, 0, 0, 0.4)",
      marginBottom: 10,
      ul: {
        width: "100%",
        float: "left",
        margin: 0,
        padding: 0,
        textAlign: "center",
        listStyle: "none",
      },
      li: {
        adding: "12px 2%",
        fontSize: 13,
        width: "auto",
        display: "inline-block",
        padding: "12px 5%",
        listStyle: "none",
        background: `url(${bullet}) right 17px no-repeat`,
        color: "#fff",
        textTransform: "uppercase",
      },
      liLast: {
        adding: "12px 2%",
        fontSize: 13,
        width: "auto",
        display: "inline-block",
        padding: "12px 5%",
        listStyle: "none",
        color: "#fff",
        textTransform: "uppercase",
      },
    },
    registerBlock: {
      width: "100%",
      float: "left",
      background: "rgba(0, 0, 0, 0.4)",
      padding: "20px 5%",
      h1: {
        width: "100%",
        float: "left",
        color: "#fff",
        fontWeight: 300,
        margin: "0 0 15px",
        fontSize: 24,
      },
      input: {
        width: "100%",
        float: "left",
        margin: "0 0 10px",
        padding: "10px 4%",
        backgroundColor: "#f4f4f4",
        fontSize: 15,
        color: "#000000",
        fontWeight: "bold",
        fontFamily: "Arial",
        border: 0,
      },
      suggestion: {
        width: "100%",
        float: "left",
        color: "#b5b5b5",
        fontSize: 14,
        fontWeight: 300,
        marginBottom: 15,
      },
    },
  },
  blueGreenBlock: {
    width: "100%",
    float: "left",
    background: `url(${blueGreenBg}) top center repeat-y`,
  },
  hireBlock: {
    width: "48%",
    float: "left",
    padding: "80px 0",
    color: "#fff",
    h1: {
      width: "100%",
      float: "left",
      fontWeight: 700,
      textTransform: "uppercase",
      fontSize: 30,
      margin: "0 0 10px",
    },
    p: {
      width: "100%",
      float: "left",
      fontSize: 20,
      margin: 0,
      padding: 0,
    },
  },
  buttonBlock: {
    width: "50%",
    float: "left",
    padding: "35px 0 25px",
    textAlign: "center",
    a: {
      width: "65%",
      display: "inline-block",
      fontSize: 16,
      color: "#cdebff",
      fontWeight: 500,
      textTransform: "uppercase",
      padding: "20px 0",
      textAlign: "center",
      margin: "0 auto 8px",
      border: "1px solid #8ccaf3",
    },
  },
};
